import 'magnific-popup';

export default {
    magnificPopup() {
        let videoLink = $('.modal-link-video');
        if (videoLink) {
            videoLink.magnificPopup({
                disableOn: 700,
                type: 'iframe',
                mainClass: 'mfp-fade',
                removalDelay: 160,
                preloader: false,
                fixedContentPos: false,
            });
        }
    },
    init() {
        // JavaScript to be fired on all pages

        // Modals (consider commenting out this and 'magnific-popup' import if not in use)
        this.magnificPopup();
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js